import { http } from '@/lib/ats-https';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  fullResponse?: boolean;
}

interface MinimumNoticeSettings {
  minimum_notice_enabled: boolean;
  minimum_notice_config: {
    value: number;
    type: 'hours' | 'days';
  };
}

const getSharedCalendarStatus = async () => {
  return http.get('/shared_calendars/show_setting');
};

const toggleSharedCalendarStatus = async (payload: any) => {
  return http.patch('/shared_calendars/update_setting', payload);
};

const getSharedCalendarUUID = async () => {
  return http.post('/shared_calendars/trigger_fetch');
};

const getCalendarsPollResponse = async (payload: any) => {
  return http.get(
    `/shared_calendars/list?fetch_uuid=${payload?.uuId}&type=${payload?.type}`
  );
};

const selectSharedCalendar = async (payload: any) => {
  return http.post('/shared_calendars/', payload);
};

const getSharedCalendarList = async () => {
  return http.get('/shared_calendars/');
};

const makeDefaultCalendar = async (payload: any) => {
  return http.patch(`/shared_calendars/update_default_calendar`, {
    default_shared_calendar_id: payload,
  });
};

const deleteCalendar = async (payload: any) => {
  return http.delete(`/shared_calendars/${payload}`, {
    fullResponse: true,
  } as CustomAxiosRequestConfig);
};

const getMinimumNoticeSettings = async (): Promise<{
  data: MinimumNoticeSettings;
}> => {
  return http.get('/ats_schedules/settings');
};

const updateMinimumNoticeSettings = async (payload: {
  minimum_notice_enabled?: boolean;
  minimum_notice_config?: {
    value: number;
    type: 'hours' | 'days';
  };
}) => {
  const requestPayload = {
    minimum_notice_enabled: payload.minimum_notice_enabled,
    ...(payload.minimum_notice_config && {
      minimum_notice_config: payload.minimum_notice_config,
    }),
  };

  return http.put('/ats_schedules/settings', requestPayload);
};

export const SCHEDULING_PREFERENCES_API_SERVICES = {
  // Shared Calendar APIs
  getSharedCalendarStatus,
  toggleSharedCalendarStatus,
  getSharedCalendarUUID,
  getCalendarsPollResponse,
  selectSharedCalendar,
  getSharedCalendarList,
  makeDefaultCalendar,
  deleteCalendar,

  // Minimum Notice APIs
  getMinimumNoticeSettings,
  updateMinimumNoticeSettings,
};
